import { c as _c } from "react/compiler-runtime";
import { isMarkdown } from '@/utils/markdown';
import { mergeClasses } from '@/utils/style';
import { MDXRemote, type MDXRemoteSerializeResult } from 'next-mdx-remote';
import React from 'react';
import { Headline } from '@/components/typography';
function PageHeadline(t0) {
  const $ = _c(13);
  const {
    className,
    id,
    anchorKey,
    text,
    width
  } = t0;
  let t1;
  if ($[0] !== text) {
    t1 = isMarkdown(text) ? <MDXRemote {...text} /> : text;
    $[0] = text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const content = t1;
  const t2 = width !== "full" && "4xl:mb-8 mb-6 xl:text-left";
  let t3;
  if ($[2] !== className || $[3] !== t2) {
    t3 = mergeClasses("text-center", t2, className);
    $[2] = className;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const classNames = t3;
  if (anchorKey) {
    let t4;
    if ($[5] !== anchorKey || $[6] !== classNames || $[7] !== content) {
      t4 = <Headline as="h1" anchorKey={anchorKey} className={classNames}>{content}</Headline>;
      $[5] = anchorKey;
      $[6] = classNames;
      $[7] = content;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  if (!id) {
    throw new Error("PageHeadline requires either id or anchorKey.");
  }
  let t4;
  if ($[9] !== classNames || $[10] !== content || $[11] !== id) {
    t4 = <Headline as="h1" id={id} className={classNames}>{content}</Headline>;
    $[9] = classNames;
    $[10] = content;
    $[11] = id;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
export default PageHeadline;